var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgGlobe(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-2 -2)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17.668,12.575a10.9,10.9,0,0,0-.242-2.25h2.025a6.919,6.919,0,0,0-.377-.9H17.189a11.093,11.093,0,0,0-1.626-3.3A6.919,6.919,0,0,0,14.129,5.7,10.029,10.029,0,0,1,16.318,9.4H13.286V5.6h-.844V9.408H9.41A10.029,10.029,0,0,1,11.6,5.7a6.907,6.907,0,0,0-1.429.422A11.093,11.093,0,0,0,8.538,9.408h-1.9a6.919,6.919,0,0,0-.382.917H8.3a10.9,10.9,0,0,0-.242,2.25,11.064,11.064,0,0,0,.281,2.458H6.35a6.941,6.941,0,0,0,.416.917H8.583A10.867,10.867,0,0,0,10.1,18.965a6.907,6.907,0,0,0,1.468.444A10.074,10.074,0,0,1,9.489,15.95h2.959v3.566h.844V15.95h2.948a10.069,10.069,0,0,1-2.081,3.459,6.908,6.908,0,0,0,1.474-.456,10.868,10.868,0,0,0,1.513-3h1.8a6.941,6.941,0,0,0,.416-.9h-2a11.064,11.064,0,0,0,.3-2.475Zm-5.226,2.458H9.213a9.951,9.951,0,0,1-.051-4.725h3.279Zm4.073,0H13.286V10.325h3.279a10.749,10.749,0,0,1-.051,4.708Z",
    transform: "translate(-1.864 -1.575)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11,2a9,9,0,1,0,9,9A9,9,0,0,0,11,2Zm0,16.875A7.875,7.875,0,1,1,18.875,11,7.875,7.875,0,0,1,11,18.875Z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGlobe);
export default __webpack_public_path__ + "static/media/globe.f0a5071ead65ab63e0e000335a34dd98.svg";
export { ForwardRef as ReactComponent };